// ViewCandidate.jsx
import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  Chip,
  Divider,
  Grid,
  Typography,
  Tooltip,
  Paper,
  Button,
  Switch,
  Popover,
  DialogActions,
  DialogContent,
  IconButton,
  DialogTitle,
  Dialog,
} from "@mui/material";

import { MdOutlineMail, MdOutlineLocalPhone, MdVerified } from "react-icons/md";
import { AiOutlineLinkedin } from "react-icons/ai";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import { SiWhatsapp } from "react-icons/si";
import { RxCrossCircled } from "react-icons/rx";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import Slider from "react-slick";
import VideoModal from "../../Candidate/CandidateDashboard/VideoModal";
import LinearProgress from "../../Candidate/CandidateDashboard/LinearProgress";

import { useSelector, useDispatch } from "react-redux";
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction";
import { ProfileProgressBarAction } from "../../../Redux/action/ProfileProgressBarAction";
import { CandidateUpdateProImg } from "../../../Redux/action/CandidateUpdateProImgAction";

import dummyDp from "../../../../src/images/userimg.jpeg";
import videoThumb from "../../../../src/images/video_img.jpg";
import Loader from "../../Common/Loader/loader";
import BackButton from "../../Common/BackButton/BackButton";
import axios from "axios";
import Swal from "sweetalert2";
import Pricing from "../../Candidate/Profile/Pricing";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { CandidateVendorProfile } from "../../../Redux/action/VendorProfileAction";
import {
  Close,
  FileOpenOutlined,
  Verified,
  VerifiedOutlined,
} from "@mui/icons-material";

// ---------- Project Carousel ----------
const ProjectCarousel = ({ images = [] }) => {
  if (!images?.length) return null;

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: images.length > 1 ? 2 : 1,
    speed: 500,
    responsive: [
      { breakpoint: 900, settings: { slidesToShow: 1 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <Slider {...settings}>
      {images.map((img, i) => (
        <Paper
          key={i}
          elevation={0}
          sx={{ p: 1, display: "flex", justifyContent: "center" }}
        >
          <img
            src={img}
            alt={`project-${i}`}
            style={{
              height: 180,
              width: "90%",
              borderRadius: 8,
              objectFit: "cover",
            }}
          />
        </Paper>
      ))}
    </Slider>
  );
};

// ---------- Main Component ----------
const ViewCandidate = () => {
  const dispatch = useDispatch();
  const { id: routeId } = useParams();
  const { userResult } = useSelector((state) => state.Auth);
  const vendorData = useSelector(
    (state) => state?.VendorProfile?.candidateVendor,
  );
  const [openResume, setOpenResume] = React.useState(false);
  const candidateData = useSelector((state) => state.Profile.result);
  const userInfo = useSelector((state) => state?.Profile?.result) || {};
  const userVideo = useSelector((state) => state?.Profile?.result?.videoUrl);
  const loading = useSelector((state) => state?.Profile?.loading);
  const profileProgress = useSelector((state) => state?.ProgressBAR?.result);
  const [candidateId, setCandidateId] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [anchorElPrice, setAnchorElPrice] = useState(null);
  const [isPricingOpen, setIsPricingOpen] = useState(false);
  const [isOpenForMarket, setIsOpenForMarket] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [pricingData, setPricingData] = useState({});

  const isSameVendor =
    userResult?.vendorid != null &&
    candidateData?.vendorId != null &&
    userResult.vendorid === candidateData.vendorId;

  useEffect(() => {
    let queryId = null;
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      queryId = params.get("candidateId");
    }

    const finalId =
      queryId ||
      routeId ||
      userResult?.userid ||
      userResult?.id ||
      userInfo?.candidateId ||
      null;
    setCandidateId(finalId);
    const getPricing = async () => {
      if (!finalId) return;
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_PATH}/ebench/candidate/${finalId}/price`,
        );
        setPricingData(response?.data?.data ?? null);
      } catch (error) {
        console.error(
          "Get Pricing API failed:",
          error?.response?.data || error.message,
        );
        setPricingData({});
      }
    };

    getPricing();
  }, []);

  useEffect(() => {
    if (candidateId) {
      dispatch(CandidateProfile(candidateId));
      dispatch(ProfileProgressBarAction(candidateId));
    }
  }, [dispatch, candidateId]);

  useEffect(() => {
    if (candidateData?.vendorId) {
      dispatch(CandidateVendorProfile(candidateData.vendorId));
    }
  }, [dispatch, candidateData?.vendorId]);

  useEffect(() => {
    setIsOpenForMarket(Boolean(userInfo?.availableForWork));
    setImagePreview(userInfo?.profileImageUrl || "");
  }, [userInfo]);

  const isPricingEmpty =
    userInfo?.candidatePrice === null &&
    pricingData &&
    !pricingData.perHour &&
    !pricingData.perDay &&
    !pricingData.perWeek &&
    !pricingData.perMonth;

  const statusBadge = userInfo?.emailVerified
    ? {
        label: "Verified",
        icon: <MdVerified color="#2b9348" />,
        sx: { background: "#d1fadf", color: "#1e7a40" },
      }
    : {
        label: "Unverified",
        icon: <RxCrossCircled color="red" />,
        sx: { background: "#ffe1e1", color: "#b91c1c" },
      };

  // File upload handler
  // const onFileChange = async (e) => {
  //   const file = e.target.files?.[0];
  //   if (!file) return;
  //   const maxSize = 1024 * 1024; // 1MB
  //   if (file.size > maxSize) {
  //     toast.error("File size exceeds 1MB. Please select a smaller file.");
  //     e.target.value = null;
  //     return;
  //   }

  //   setImagePreview(URL.createObjectURL(file));
  //   setSelectedImageFile(file);

  //   const form = new FormData();
  //   form.append("image", file);
  //   form.append("candidateId", candidateId);

  //   await dispatch(CandidateUpdateProImg(form))
  //     .then(() => {
  //       dispatch(CandidateProfile(candidateId));
  //       dispatch(ProfileProgressBarAction(candidateId));
  //       toast.success("Profile image uploaded");
  //     })
  //     .catch((err) => {
  //       console.error("Upload error:", err);
  //       toast.error("Error uploading image");
  //     });
  // };

  const handleEnableAvailability = async () => {
    try {
      setIsOpenForMarket(true);
      const content = {
        candidateId: userInfo?.candidateId || candidateId,
        availableForWork: true,
      };
      await axios.put(
        `${process.env.REACT_APP_API_PATH}/ebench/update_Candidate`,
        content,
      );
      dispatch(CandidateProfile(candidateId));
      toast.success("Availability enabled");
    } catch (err) {
      console.error("Failed to enable availability:", err);
      setIsOpenForMarket(Boolean(userInfo?.availableForWork));
      toast.error("Failed to update availability");
    }
  };

  const handleDisableConfirm = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      .custom-confirm-button { background-color: #286a94 !important; color: white; }
      .custom-title { border-bottom: 0.5px solid #adadad; text-align:center; color: #286a94 !important; padding-bottom: 10px; }
    `;
    document.getElementsByTagName("head")[0].appendChild(style);

    const para = document.createElement("div");
    para.className = "custom-paragraph";
    para.innerText =
      "Are you sure you want to change the availability for this candidate?";

    Swal.fire({
      title: "Change Availability",
      html: para.outerHTML,
      showCancelButton: true,
      confirmButtonText: "Yes",
      customClass: {
        title: "custom-title",
        confirmButton: "custom-confirm-button",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsOpenForMarket(false);
          const content = {
            candidateId: userInfo?.candidateId || candidateId,
            availableForWork: false,
          };
          await axios.put(
            `${process.env.REACT_APP_API_PATH}/ebench/update_Candidate`,
            content,
          );
          dispatch(CandidateProfile(candidateId));
          toast.success("Availability disabled");
        } catch (err) {
          console.error("Disable error:", err);
          Swal.fire(
            "Error",
            "There was an error updating availability",
            "error",
          );
        }
      }
    });
  };

  const handleAvailabilityToggle = () => {
    if (isOpenForMarket === true) handleDisableConfirm();
    else handleEnableAvailability();
  };

  const handlePriceClick = (e) => {
    setAnchorElPrice(anchorElPrice ? null : e.currentTarget);
    setIsPricingOpen((v) => !v);
  };
  const openPrice = Boolean(anchorElPrice);

  // copy LinkedIn
  const handleCopyLinkedIn = () => {
    if (!userInfo?.linkedIn) {
      toast.error("No LinkedIn profile found");
      return;
    }
    navigator.clipboard.writeText(userInfo.linkedIn);
    toast.success("LinkedIn copied");
  };

  const truncate = (text = "", maxLength = 20) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  // loading
  if (loading) {
    return (
      <Box
        sx={{
          height: "60vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ px: 3, paddingBottom: 4, paddingTop: 0.5 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4} lg={3} sx={{ minWidth: 0 }}>
            <Box
              sx={{
                position: { xs: "static", md: "sticky" },
                top: 20,
                zIndex: 5,

                width: "100%",
                minWidth: 0,
                overflow: "hidden",
              }}
            >
              <Card
                sx={{
                  p: { xs: 2, md: 3 },
                  borderRadius: 4,
                  textAlign: "center",
                  background: "linear-gradient(135deg, #EBF5FF, #FFFFFF)",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                  <BackButton />
                </Box>

                <Avatar
                  src={
                    isSameVendor || userResult?.usertype === "ADMIN"
                      ? userInfo?.profileImageUrl
                      : dummyDp
                  }
                  sx={{
                    width: { xs: 140, sm: 160, md: 200 },
                    height: { xs: 140, sm: 160, md: 200 },
                    mx: "auto",
                    mb: 2,
                    border: "4px solid #fff",
                    boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
                  }}
                  imgProps={{
                    loading: "eager",
                    decoding: "async",
                  }}
                />

                {/* {isSameVendor && (
                  <Box sx={{ textAlign: "center", mb: 2 }}>
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={onFileChange}
                    />

                    <Button
                      variant="contained"
                      onClick={() => fileInputRef.current?.click()}
                      sx={{
                        background: "#286a94",
                        fontWeight: 600,
                        px: 3,
                        textTransform: "none",
                      }}
                    >
                      Upload Photo
                    </Button>
                  </Box>
                )} */}

                {(isSameVendor || userResult?.usertype === "ADMIN") && (
                  <Typography variant="h6" fontWeight={700}>
                    {truncate(
                      userInfo?.firstName || "",
                      window.innerWidth < 520 ? 15 : 15,
                    )}{" "}
                    {truncate(
                      userInfo?.lastName || "",
                      window.innerWidth < 520 ? 15 : 15,
                    )}
                  </Typography>
                )}

                <Tooltip
                  title={
                    userInfo?.emailVerified
                      ? "Verified profile"
                      : "Unverified profile"
                  }
                >
                  <Chip
                    icon={statusBadge.icon}
                    label={statusBadge.label}
                    size="small"
                    sx={{ ...statusBadge.sx, mt: 1, fontWeight: 600 }}
                  />
                </Tooltip>

                <Divider sx={{ my: 2 }} />
                <Box sx={{ mt: 0.5, textAlign: "left" }}>
                  <Typography
                    fontWeight={700}
                    sx={{
                      textTransform: "uppercase",
                      fontSize: "13px",
                      opacity: 0.9,
                      mb: 1.5,
                    }}
                  >
                    Availability
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "15px",
                        fontWeight: 500,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      This candidate is
                      <Chip
                        label={
                          userInfo?.availableForWork
                            ? "Available"
                            : "Unavailable"
                        }
                        sx={{
                          fontWeight: 600,
                          p: 0.5,
                          color: userInfo?.availableForWork
                            ? "#1E7A40"
                            : "#B91C1C",
                          background: userInfo?.availableForWork
                            ? "#D1FADF"
                            : "#FFE1E1",
                          borderRadius: "6px",
                        }}
                      />
                    </Typography>

                    {isSameVendor && (
                      <Tooltip
                        title={
                          userInfo?.availableForWork
                            ? "Click to mark as unavailable"
                            : "Click to mark as available"
                        }
                      >
                        <Switch
                          checked={userInfo?.availableForWork}
                          onChange={handleAvailabilityToggle}
                          sx={{
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: "#215b7f",
                            },
                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                              {
                                backgroundColor: "#215b7f",
                              },
                          }}
                        />
                      </Tooltip>
                    )}
                  </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                {(isSameVendor || userResult?.usertype === "ADMIN") && (
                  <>
                    <Typography
                      fontWeight={700}
                      sx={{
                        textTransform: "uppercase",
                        textAlign: "left",
                        fontSize: "13px",
                        opacity: 0.9,
                        mb: 2,
                      }}
                    >
                      Contact Information
                    </Typography>

                    <Box sx={{ display: "grid", gap: 2, textAlign: "left" }}>
                      {/* Email */}
                      <Tooltip arrow title={userInfo?.email || "N/A"}>
                        <Box
                          onClick={() =>
                            userInfo?.email &&
                            window.open(`mailto:${userInfo.email}`)
                          }
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            cursor: userInfo?.email ? "pointer" : "default",
                            fontSize: "15px",
                            color: "#0E3F6F",
                            transition: "0.3s",
                            "&:hover": {
                              color: userInfo?.email ? "#286A94" : undefined,
                            },
                          }}
                        >
                          <MdOutlineMail size={20} color="#286a94" />
                          <Typography>
                            {userInfo?.email
                              ? userInfo.email.length > 30
                                ? userInfo.email.slice(0, 30) + "..."
                                : userInfo.email
                              : "N/A"}
                          </Typography>
                        </Box>
                      </Tooltip>

                      {/* Phone */}
                      {userInfo?.mobile && (
                        <Tooltip arrow title="Call">
                          <Box
                            onClick={() =>
                              window.open(
                                `tel:+${userInfo?.dialCode}${userInfo.mobile}`,
                              )
                            }
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              fontSize: "15px",
                              color: "#0E3F6F",
                              transition: "0.3s",
                              "&:hover": { color: "#286A94" },
                              gap: 1,
                            }}
                          >
                            <MdOutlineLocalPhone size={20} color="#286a94" />
                            <Typography>
                              +{userInfo?.dialCode} {userInfo.mobile}
                            </Typography>
                          </Box>
                        </Tooltip>
                      )}

                      {/* LinkedIn */}
                      {userInfo?.linkedIn && (
                        <Tooltip arrow title="Click to Copy URL">
                          <Box
                            onClick={handleCopyLinkedIn}
                            sx={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "15px",
                              color: "#0E3F6F",
                              transition: "0.3s",
                              "&:hover": { color: "#286A94" },
                              gap: 1,
                            }}
                          >
                            <AiOutlineLinkedin size={20} color="#286a94" />
                            <Typography>LinkedIn Profile</Typography>
                          </Box>
                        </Tooltip>
                      )}

                      {/* WhatsApp */}
                      {userInfo?.whatsapp && (
                        <Tooltip arrow title="Open WhatsApp Chat">
                          <Box
                            onClick={() =>
                              window.open(
                                `https://wa.me/${userInfo?.dialCode}${userInfo.whatsapp}`,
                                "_blank",
                              )
                            }
                            sx={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "15px",
                              color: "#0E3F6F",
                              transition: "0.3s",
                              "&:hover": { color: "#286A94" },
                              gap: 1,
                            }}
                          >
                            <SiWhatsapp size={20} color="#25D366" />
                            <Typography>
                              +{userInfo?.dialCode} {userInfo.whatsapp}
                            </Typography>
                          </Box>
                        </Tooltip>
                      )}
                    </Box>
                  </>
                )}
              </Card>
            </Box>
          </Grid>

          <Grid item xs={12} md={8} lg={9}>
            <Card
              sx={{
                p: 4,
                borderRadius: 4,
                boxShadow: "0px 8px 24px rgba(0,0,0,0.04)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                  gap: 2,
                  pb: 1,
                }}
              >
                {/* LEFT SIDE */}
                <Box sx={{ flex: 1, minWidth: "250px" }}>
                  <Box>
                    {/* Designation + Verified */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        flexWrap: "wrap",
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 700,
                          color: "#0f172a",
                          lineHeight: 1.3,
                        }}
                      >
                        {userInfo?.currentDesignation || "N/A"}
                      </Typography>

                      <Tooltip
                        title={
                          userInfo?.emailVerified
                            ? "Verified profile"
                            : "Profile not verified"
                        }
                      >
                        {userInfo?.emailVerified ? (
                          <Verified
                            sx={{
                              color: "#2b9348",
                              fontSize: 22,
                            }}
                          />
                        ) : (
                          <VerifiedOutlined
                            sx={{
                              color: "#b91c1c",
                              fontSize: 22,
                            }}
                          />
                        )}
                      </Tooltip>
                    </Box>

                    {/* Candidate ID */}
                    <Box
                      sx={{
                        mt: 0.8,
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.8,
                        px: 1.5,
                        py: 0.4,
                        borderRadius: 999,
                        background: "#F1F7FB",
                        border: "1px solid #E2E8F0",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 14,
                          color: "#64748b",
                          fontWeight: 500,
                          textTransform: "uppercase",
                        }}
                      >
                        Candidate ID :
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: 700,
                          color: "#286a94",
                          letterSpacing: "0.3px",
                        }}
                      >
                        {userInfo?.candidateEmpId || "--"}
                      </Typography>
                    </Box>
                  </Box>

                  {(isSameVendor || userResult?.usertype === "ADMIN") && (
                    <Box sx={{ mt: 2, maxWidth: 320 }}>
                      <LinearProgress profileProgress={profileProgress || 0} />
                    </Box>
                  )}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    gap: 1.5,
                    flexWrap: "wrap",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {/* PRICE BUTTON */}
                  {((userInfo?.candidatePrice != null &&
                    isSameVendor &&
                    parseInt(userInfo?.keyExperience || "0", 10) >= 1) ||
                    userResult.usertype === "ADMIN") && (
                    <>
                      <Button
                        variant="outlined"
                        onClick={handlePriceClick}
                        startIcon={
                          <PaidOutlinedIcon sx={{ color: "#215b7f" }} />
                        }
                        endIcon={
                          isPricingOpen ? (
                            <FaChevronDown size={14} />
                          ) : (
                            <FaChevronRight size={14} />
                          )
                        }
                        sx={{
                          textTransform: "none",
                          borderColor: "#215b7f",
                          color: "#215b7f",
                          fontWeight: 600,
                          px: 2.2,
                          "&:hover": {
                            backgroundColor: "rgba(33, 91, 127, 0.1)",
                            borderColor: "#215b7f",
                          },
                        }}
                      >
                        Price
                      </Button>

                      <Popover
                        open={openPrice}
                        anchorEl={anchorElPrice}
                        onClose={() => {
                          setAnchorElPrice(null);
                          setIsPricingOpen(false);
                        }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                      >
                        <Paper
                          sx={{
                            p: 1.5,
                            minWidth: 230,
                            borderRadius: 2,
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          {(() => {
                            const currency = userInfo?.candidatePrice?.currency;
                            const currencySymbol =
                              currency === "INR"
                                ? "₹"
                                : currency === "USD"
                                  ? "$"
                                  : currency + " ";

                            if (isPricingEmpty) {
                              return (
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: "#64748b",
                                    fontStyle: "italic",
                                    textAlign: "center",
                                    py: 1,
                                  }}
                                >
                                  No information available
                                </Typography>
                              );
                            }

                            return (
                              <>
                                {/* Per Hour */}
                                {userInfo?.candidatePrice?.perHour && (
                                  <>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#215b7f",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {currencySymbol}
                                      {userInfo?.candidatePrice?.perHour} / hr
                                    </Typography>
                                    <Divider
                                      sx={{
                                        my: 1,
                                        borderColor: "rgba(33,91,127,0.15)",
                                      }}
                                    />
                                  </>
                                )}

                                {/* Per Day */}
                                {userInfo?.candidatePrice?.perDay && (
                                  <>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#215b7f",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {currencySymbol}
                                      {userInfo?.candidatePrice?.perDay} / day
                                    </Typography>
                                    <Divider
                                      sx={{
                                        my: 1,
                                        borderColor: "rgba(33,91,127,0.15)",
                                      }}
                                    />
                                  </>
                                )}

                                {/* Per Week */}
                                {userInfo?.candidatePrice?.perWeek && (
                                  <>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#215b7f",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {currencySymbol}
                                      {userInfo?.candidatePrice?.perWeek} / week
                                    </Typography>
                                    <Divider
                                      sx={{
                                        my: 1,
                                        borderColor: "rgba(33,91,127,0.15)",
                                      }}
                                    />
                                  </>
                                )}

                                {/* Per Month */}
                                {userInfo?.candidatePrice?.perMonth && (
                                  <>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#215b7f",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {currencySymbol}
                                      {userInfo?.candidatePrice?.perMonth} /
                                      month
                                    </Typography>
                                  </>
                                )}
                                {userInfo?.candidatePrice?.salaryMode ===
                                  "CTC" &&
                                  userInfo?.candidatePrice?.ctc &&
                                  userResult.usertype === "ADMIN" && (
                                    <>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "#215b7f",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {currencySymbol}
                                        {userInfo?.candidatePrice?.ctc} / CTC
                                      </Typography>
                                    </>
                                  )}
                              </>
                            );
                          })()}
                        </Paper>
                      </Popover>
                    </>
                  )}

                  {userInfo?.candidatePrice != null &&
                    pricingData &&
                    !isSameVendor &&
                    userResult?.usertype !== "ADMIN" && (
                      <>
                        <Button
                          variant="outlined"
                          onClick={handlePriceClick}
                          startIcon={
                            <PaidOutlinedIcon sx={{ color: "#215b7f" }} />
                          }
                          endIcon={
                            isPricingOpen ? (
                              <FaChevronDown size={14} />
                            ) : (
                              <FaChevronRight size={14} />
                            )
                          }
                          sx={{
                            textTransform: "none",
                            borderColor: "#215b7f",
                            color: "#215b7f",
                            fontWeight: 600,
                            px: 2.2,
                            "&:hover": {
                              backgroundColor: "rgba(33, 91, 127, 0.1)",
                              borderColor: "#215b7f",
                            },
                          }}
                        >
                          Price
                        </Button>

                        <Popover
                          open={openPrice}
                          anchorEl={anchorElPrice}
                          onClose={() => {
                            setAnchorElPrice(null);
                            setIsPricingOpen(false);
                          }}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                        >
                          <Paper
                            sx={{
                              p: 1.5,
                              minWidth: 230,
                              borderRadius: 2,
                              border: "1px solid #e0e0e0",
                            }}
                          >
                            {(() => {
                              const currency = pricingData?.currency;
                              const currencySymbol =
                                currency === "INR"
                                  ? "₹"
                                  : currency === "USD"
                                    ? "$"
                                    : currency + " ";

                              if (isPricingEmpty) {
                                return (
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: "#64748b",
                                      fontStyle: "italic",
                                      textAlign: "center",
                                      py: 1,
                                    }}
                                  >
                                    No information available
                                  </Typography>
                                );
                              }

                              return (
                                <>
                                  {/* Per Hour */}
                                  {pricingData?.perHour && (
                                    <>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "#215b7f",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {currencySymbol}
                                        {pricingData.perHour} / hr
                                      </Typography>
                                      <Divider
                                        sx={{
                                          my: 1,
                                          borderColor: "rgba(33,91,127,0.15)",
                                        }}
                                      />
                                    </>
                                  )}

                                  {/* Per Day */}
                                  {pricingData?.perDay && (
                                    <>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "#215b7f",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {currencySymbol}
                                        {pricingData?.perDay} / day
                                      </Typography>
                                      <Divider
                                        sx={{
                                          my: 1,
                                          borderColor: "rgba(33,91,127,0.15)",
                                        }}
                                      />
                                    </>
                                  )}

                                  {/* Per Week */}
                                  {pricingData?.perWeek && (
                                    <>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "#215b7f",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {currencySymbol}
                                        {pricingData?.perWeek} / week
                                      </Typography>
                                      <Divider
                                        sx={{
                                          my: 1,
                                          borderColor: "rgba(33,91,127,0.15)",
                                        }}
                                      />
                                    </>
                                  )}

                                  {/* Per Month */}
                                  {pricingData?.perMonth && (
                                    <>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "#215b7f",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {currencySymbol}
                                        {pricingData?.perMonth} / month
                                      </Typography>
                                    </>
                                  )}
                                  {/* {pricingData?.salaryMode === "CTC" &&
                                    pricingData?.ctc && (
                                      <>
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            color: "#215b7f",
                                            fontWeight: 600,
                                          }}
                                        >
                                          {currencySymbol}
                                          {pricingData?.ctc} / CTC
                                        </Typography>
                                      </>
                                    )} */}
                                </>
                              );
                            })()}
                          </Paper>
                        </Popover>
                      </>
                    )}

                  {userInfo?.resumeFileUrl &&
                    (isSameVendor || userResult?.usertype === "ADMIN") && (
                      <Button
                        variant="outlined"
                        onClick={() => setOpenResume(true)}
                        startIcon={
                          <VisibilityOutlinedIcon sx={{ color: "#215b7f" }} />
                        }
                        sx={{
                          textTransform: "none",
                          borderColor: "#215b7f",
                          color: "#215b7f",
                          fontWeight: 600,
                          px: 2.5,
                          "&:hover": {
                            backgroundColor: "rgba(33, 91, 127, 0.08)",
                            borderColor: "#215b7f",
                          },
                        }}
                      >
                        Resume
                      </Button>
                    )}

                  {/* INTRODUCTION VIDEO */}
                  {userInfo?.videoUrl &&
                    (isSameVendor || userResult?.usertype === "ADMIN") && (
                      <Button
                        variant="outlined"
                        startIcon={
                          <PlayCircleOutlineIcon sx={{ color: "#215b7f" }} />
                        }
                        onClick={() => setShowVideoModal(true)}
                        sx={{
                          textTransform: "none",
                          borderColor: "#215b7f",
                          color: "#215b7f !important",
                          fontWeight: 600,
                          px: 2.5,
                          "&:hover": {
                            backgroundColor: "rgba(33, 91, 127, 0.08)",
                            borderColor: "#215b7f",
                          },
                        }}
                      >
                        Introduction
                      </Button>
                    )}
                </Box>
              </Box>

              {userInfo?.overview && (
                <Box
                  sx={{
                    mt: 3,
                    p: 2.5,
                    borderRadius: 3,
                    background: "#F8FAFC",
                    borderLeft: "4px solid #286a94",
                  }}
                >
                  {/* Label */}
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontWeight: 700,
                      color: "#286a94",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      mb: 0.75,
                    }}
                  >
                    Professional Summary
                  </Typography>

                  {/* Content */}
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: "#475569",
                      lineHeight: 1.7,
                      whiteSpace: "pre-line",
                    }}
                  >
                    {userInfo.overview}
                  </Typography>
                </Box>
              )}

              <Divider sx={{ my: 4 }} />

              <Box sx={{ mt: 4 }}>
                <Grid container spacing={2}>
                  {/* Location */}
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        background: "#F1F7FB",
                        border: "1px solid #E2E8F0",
                        display: "flex",
                        gap: 1.5,
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: 42,
                          height: 42,
                          borderRadius: "50%",
                          background: "#E6F0F8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LocationOnIcon sx={{ color: "#286a94" }} />
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: "#286a94",
                            textTransform: "uppercase",
                          }}
                        >
                          Location
                        </Typography>
                        <Typography sx={{ color: "#475569", fontSize: 14 }}>
                          {[userInfo?.city, userInfo?.state, userInfo?.country]
                            .filter(Boolean)
                            .join(", ") || "—"}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  {/* Experience */}
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        background: "#F1F7FB",
                        border: "1px solid #E2E8F0",
                        display: "flex",
                        gap: 1.5,
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: 42,
                          height: 42,
                          borderRadius: "50%",
                          background: "#E6F0F8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <WorkHistoryIcon sx={{ color: "#286a94" }} />
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: "#286a94",
                            textTransform: "uppercase",
                          }}
                        >
                          Experience
                        </Typography>
                        <Typography sx={{ color: "#475569", fontSize: "15px" }}>
                          {(() => {
                            const yearsRaw = parseInt(
                              userInfo?.keyExperience,
                              10,
                            );
                            const monthsRaw = parseInt(
                              userInfo?.keyExperienceInMonth,
                              10,
                            );
                            const years = Number.isNaN(yearsRaw) ? 0 : yearsRaw;
                            const months = Number.isNaN(monthsRaw)
                              ? 0
                              : monthsRaw;

                            if (years === 0 && months === 0) {
                              return "Fresher";
                            }
                            if (years === 0) {
                              return `${months} Month${months > 1 ? "s" : ""}`;
                            }
                            if (months === 0) {
                              return `${years} Year${years > 1 ? "s" : ""}`;
                            }
                            return `${years} Year${
                              years > 1 ? "s" : ""
                            } ${months} Month${months > 1 ? "s" : ""}`;
                          })()}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              {candidateData?.vendorId !== null &&
                (isSameVendor || userResult?.usertype === "ADMIN") && (
                  <Box sx={{ mt: 4 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          background: "#E6F0F8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <BusinessOutlinedIcon
                          sx={{
                            color: "#286a94",
                            fontSize: 22,
                          }}
                        />
                      </Box>

                      <Typography variant="h6" fontWeight={700} color="#286a94">
                        Vendor Information
                      </Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />
                    <Grid container spacing={2}>
                      {/* Vendor Name */}
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ textAlign: "left" }}>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "14px",
                              color: "#0E3F6F",
                              mb: 0.5,
                            }}
                          >
                            Vendor Name
                          </Typography>

                          <Typography
                            sx={{ color: "#475569", fontSize: "15px" }}
                          >
                            {vendorData?.firstName && vendorData?.lastName
                              ? `${vendorData.firstName} ${vendorData.lastName}`
                              : "N/A"}
                          </Typography>
                        </Box>
                      </Grid>

                      {/* Vendor ID */}
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ textAlign: "left" }}>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "14px",
                              color: "#0E3F6F",
                              mb: 0.5,
                            }}
                          >
                            Vendor ID
                          </Typography>

                          {vendorData?.vendorEmpId ? (
                            <Box
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                px: 1.5,
                                py: 0.4,
                                borderRadius: "999px",
                                backgroundColor: "#E6F0F8",
                                border: "1px solid #B6D4EA",
                                color: "#0E3F6F",
                                fontSize: "13px",
                                fontWeight: 600,
                                letterSpacing: "0.3px",
                              }}
                            >
                              {vendorData.vendorEmpId}
                            </Box>
                          ) : (
                            <Typography
                              sx={{ color: "#475569", fontSize: "15px" }}
                            >
                              N/A
                            </Typography>
                          )}
                        </Box>
                      </Grid>

                      {/* Company Name */}
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ textAlign: "left" }}>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "14px",
                              color: "#0E3F6F",
                              mb: 0.5,
                            }}
                          >
                            Company Name
                          </Typography>

                          {vendorData?.company ? (
                            <Box
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 1,
                                px: 1.5,
                                py: 0.5,
                                borderRadius: "999px",
                                backgroundColor: "#E6F0F8",
                                border: "1px solid #B6D4EA",
                                color: "#0E3F6F",
                                fontSize: "13px",
                                fontWeight: 600,
                                letterSpacing: "0.3px",
                              }}
                            >
                              {/* Company Logo */}
                              {vendorData?.companyLogoUrl && (
                                <Avatar
                                  src={vendorData.companyLogoUrl}
                                  alt={vendorData.company}
                                  imgProps={{
                                    loading: "eager",
                                    decoding: "async",
                                  }}
                                  sx={{
                                    width: 22,
                                    height: 22,
                                    bgcolor: "#ffffff",
                                    border: "1px solid #B6D4EA",
                                  }}
                                />
                              )}

                              {/* Company Name */}
                              <Typography
                                sx={{ fontSize: "13px", fontWeight: 600 }}
                              >
                                {vendorData.company}
                              </Typography>
                            </Box>
                          ) : (
                            <Typography
                              sx={{ color: "#475569", fontSize: "15px" }}
                            >
                              N/A
                            </Typography>
                          )}
                        </Box>
                      </Grid>

                      {/* Vendor Email */}
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ textAlign: "left" }}>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "14px",
                              color: "#0E3F6F",
                              mb: 0.5,
                            }}
                          >
                            Vendor Email
                          </Typography>

                          <Typography
                            sx={{ color: "#475569", fontSize: "15px" }}
                          >
                            {vendorData?.email || "N/A"}
                          </Typography>
                        </Box>
                      </Grid>

                      {/* Vendor Phone */}
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ textAlign: "left" }}>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "14px",
                              color: "#0E3F6F",
                              mb: 0.5,
                            }}
                          >
                            Contact Number
                          </Typography>

                          <Typography
                            sx={{ color: "#475569", fontSize: "15px" }}
                          >
                            {vendorData?.dialCode && vendorData?.mobile
                              ? `+${vendorData.dialCode} ${vendorData.mobile}`
                              : "N/A"}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )}

              <Divider sx={{ my: 4 }} />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 1.5,
                  }}
                >
                  <Box
                    sx={{
                      width: 38,
                      height: 38,
                      borderRadius: "50%",
                      background: "#E6F0F8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <BuildOutlinedIcon
                      sx={{
                        color: "#286a94",
                        fontSize: 22,
                      }}
                    />
                  </Box>

                  <Box>
                    <Typography variant="h6" fontWeight={700} color="#286a94">
                      Skills
                    </Typography>
                    <Typography sx={{ fontSize: 13, color: "#64748b" }}>
                      Technical & professional expertise
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.2, mt: 1 }}>
                {(userInfo?.candidateSkills || []).length > 0 ? (
                  userInfo.candidateSkills.map((item, idx) => (
                    <Chip
                      key={idx}
                      label={item.skills}
                      sx={{
                        background: "#e9f2ff",
                        borderRadius: "999px",
                        px: 2,
                        py: 1,
                        fontWeight: 600,
                        fontSize: "13px",
                      }}
                    />
                  ))
                ) : (
                  <Typography sx={{ color: "#475569" }}>
                    No skills added
                  </Typography>
                )}
              </Box>

              <Divider sx={{ my: 4 }} />

              {/* PROJECTS */}
              <Box sx={{ mt: 4 }}>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
                >
                  <Box
                    sx={{
                      width: 38,
                      height: 38,
                      borderRadius: "50%",
                      background: "#E6F0F8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <AssignmentOutlinedIcon
                      sx={{
                        color: "#286a94",
                        fontSize: 22,
                      }}
                    />
                  </Box>

                  <Typography variant="h6" fontWeight={700} color="#286a94">
                    Projects
                  </Typography>
                </Box>

                {(!userInfo?.candidateProjects ||
                  userInfo?.candidateProjects.length === 0) && (
                  <Box
                    sx={{
                      mt: 3,
                      p: 4,
                      textAlign: "center",
                      border: "2px dashed #bcd3df",
                      borderRadius: 3,
                      background: "#f8fcff",
                    }}
                  >
                    <Typography
                      sx={{ mb: 2, fontSize: "16px", color: "#4b5563" }}
                    >
                      No projects added yet.
                    </Typography>
                  </Box>
                )}

                {userInfo?.candidateProjects?.length > 0 && (
                  <>
                    <Divider sx={{ my: 3 }} />
                    <Box sx={{ mt: 2 }}>
                      {userInfo.candidateProjects.map((proj, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            background: "#F9FAFB",
                            border: "1px solid #E5E7EB",
                            borderRadius: 3,
                            p: 3,
                            mb: 3,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 2,
                            }}
                          >
                            <Chip
                              label={`#${idx + 1}`}
                              sx={{
                                background: "#286a94",
                                color: "white",
                                mr: 2,
                                fontWeight: 600,
                              }}
                            />
                            <Typography
                              sx={{ fontSize: "18px", fontWeight: 600 }}
                            >
                              {proj.projectName || "Untitled Project"}
                            </Typography>
                          </Box>

                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <Typography
                                sx={{ fontWeight: 600, color: "#0E3F6F" }}
                              >
                                Role
                              </Typography>
                              <Typography sx={{ color: "#475569" }}>
                                {proj.role || "--"}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                              <Typography
                                sx={{ fontWeight: 600, color: "#0E3F6F" }}
                              >
                                Duration
                              </Typography>
                              <Typography sx={{ color: "#475569" }}>
                                {proj.duration || "--"}
                              </Typography>
                            </Grid>

                            <Grid item xs={12}>
                              <Typography
                                sx={{ fontWeight: 600, color: "#0E3F6F" }}
                              >
                                Project URL
                              </Typography>
                              {proj?.projectUrl ? (
                                <Typography
                                  component="a"
                                  href={
                                    proj.projectUrl.startsWith("http")
                                      ? proj.projectUrl
                                      : `https://${proj.projectUrl}`
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  sx={{
                                    fontSize: "15px",
                                    color: "#2563eb",
                                    wordBreak: "break-word",
                                    cursor: "pointer",
                                    "&:hover": { textDecoration: "underline" },
                                  }}
                                >
                                  {proj.projectUrl}
                                </Typography>
                              ) : (
                                <Typography sx={{ color: "#475569" }}>
                                  --
                                </Typography>
                              )}
                            </Grid>

                            <Grid item xs={12}>
                              <Typography
                                sx={{ fontWeight: 600, color: "#0E3F6F" }}
                              >
                                Description
                              </Typography>
                              <Typography
                                sx={{
                                  color: "#475569",
                                  whiteSpace: "pre-line",
                                }}
                              >
                                {proj.description || "--"}
                              </Typography>
                            </Grid>

                            <Grid item xs={12}>
                              <Typography
                                sx={{ fontWeight: 600, color: "#0E3F6F" }}
                              >
                                Technology Used
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 1,
                                  mt: 1,
                                }}
                              >
                                {proj?.technologies?.length > 0 ? (
                                  proj.technologies.map((t, i) => (
                                    <Chip
                                      key={i}
                                      label={t}
                                      sx={{
                                        background: "#eef6ff",
                                        fontWeight: 500,
                                      }}
                                    />
                                  ))
                                ) : (
                                  <Typography sx={{ color: "#475569" }}>
                                    --
                                  </Typography>
                                )}
                              </Box>
                            </Grid>
                          </Grid>

                          {proj?.projectImages?.length > 0 && (
                            <Box sx={{ mt: 3 }}>
                              <Typography
                                sx={{
                                  fontWeight: 600,
                                  mb: 1,
                                  fontSize: "14px",
                                  color: "#0E3F6F",
                                }}
                              >
                                Screenshots
                              </Typography>
                              <ProjectCarousel images={proj.projectImages} />
                            </Box>
                          )}
                        </Box>
                      ))}
                    </Box>
                  </>
                )}
              </Box>

              <Divider sx={{ my: 3 }} />

              {/* EDUCATION */}
              <Box sx={{ mt: 5 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      background: "#E6F0F8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <SchoolOutlinedIcon
                      sx={{
                        color: "#286a94",
                        fontSize: 22,
                      }}
                    />
                  </Box>

                  <Typography variant="h6" fontWeight={700} color="#286a94">
                    Education
                  </Typography>
                </Box>
                <Divider sx={{ my: 3 }} />

                {(!userInfo?.educations ||
                  userInfo?.educations?.length === 0) && (
                  <Box
                    sx={{
                      p: 4,
                      textAlign: "center",
                      border: "2px dashed #bcd3df",
                      borderRadius: 3,
                      background: "#f8fcff",
                      color: "#475569",
                    }}
                  >
                    🎓 No education records found.
                  </Box>
                )}

                {userInfo?.educations?.length > 0 && (
                  <Box sx={{ mt: 2 }}>
                    {userInfo.educations.map((item, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          p: 3,
                          borderRadius: 3,
                          mb: 2.5,
                          background: "#F9FAFB",
                          border: "1px solid #E5E7EB",
                          "&:hover": { background: "#f1f8ff" },
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", mb: 2 }}
                        >
                          <Chip
                            label={`#${idx + 1}`}
                            sx={{
                              background: "#286a94",
                              color: "white",
                              mr: 2,
                              fontWeight: 600,
                            }}
                          />
                          <Typography
                            sx={{ fontSize: "18px", fontWeight: 600 }}
                          >
                            {item?.degreeName || item?.type || "Education"}
                          </Typography>
                        </Box>

                        <Divider sx={{ mb: 2 }} />

                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "14px",
                                textTransform: "uppercase",
                                color: "#0E3F6F",
                              }}
                            >
                              University / Board
                            </Typography>
                            <Typography
                              sx={{ fontSize: "15px", color: "#475569" }}
                            >
                              {item?.institutionName ||
                                item?.board ||
                                item?.university ||
                                "--"}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={3}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "14px",
                                textTransform: "uppercase",
                                color: "#0E3F6F",
                              }}
                            >
                              Passing Year
                            </Typography>
                            <Typography
                              sx={{ fontSize: "15px", color: "#475569" }}
                            >
                              {item?.educationStatus === "PURSUING"
                                ? "Pursuing"
                                : item?.passingYear || "--"}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={3}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "14px",
                                textTransform: "uppercase",
                                color: "#0E3F6F",
                              }}
                            >
                              Grade / Percentage
                            </Typography>
                            <Typography
                              sx={{ fontSize: "15px", color: "#475569" }}
                            >
                              {item?.percentage ? `${item.percentage}%` : "--"}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>

              <Divider sx={{ my: 3 }} />

              {/* CERTIFICATIONS */}
              <Box sx={{ mt: 5 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      background: "#E6F0F8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <WorkspacePremiumOutlinedIcon
                      sx={{
                        color: "#286a94",
                        fontSize: 22,
                      }}
                    />
                  </Box>

                  <Typography variant="h6" fontWeight={700} color="#286a94">
                    Certifications
                  </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                {(!userInfo?.candidateCertificate ||
                  userInfo?.candidateCertificate.length === 0) && (
                  <Box
                    sx={{
                      p: 4,
                      textAlign: "center",
                      border: "2px dashed #bcd3df",
                      borderRadius: 3,
                      background: "#f8fcff",
                      color: "#475569",
                    }}
                  >
                    🎓 No certifications added yet.
                  </Box>
                )}

                {userInfo?.candidateCertificate?.length > 0 && (
                  <Box sx={{ mt: 2 }}>
                    {userInfo.candidateCertificate.map((item, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          background: "#F9FAFB",
                          border: "1px solid #E5E7EB",
                          p: 2.5,
                          borderRadius: 3,
                          mb: 2.5,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", mb: 2 }}
                        >
                          <Chip
                            label={`#${idx + 1}`}
                            sx={{
                              background: "#286a94",
                              color: "white",
                              mr: 2,
                              fontWeight: 600,
                            }}
                          />
                          <Typography
                            sx={{ fontSize: "18px", fontWeight: 600 }}
                          >
                            {item?.courseName || "Untitled Certification"}
                          </Typography>
                        </Box>

                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#0E3F6F",
                              }}
                            >
                              Issued By
                            </Typography>
                            <Typography
                              sx={{ fontSize: "15px", color: "#475569" }}
                            >
                              {item?.courseProvider || "--"}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#0E3F6F",
                              }}
                            >
                              Issued Year
                            </Typography>
                            <Typography
                              sx={{ fontSize: "15px", color: "#475569" }}
                            >
                              {item?.year || "--"}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: "14px",
                                color: "#0E3F6F",
                              }}
                            >
                              Duration
                            </Typography>
                            <Typography
                              sx={{ fontSize: "15px", color: "#475569" }}
                            >
                              {item?.duration || "--"}
                            </Typography>
                          </Grid>

                          {item?.certificateImageUrl && (
                            <Grid item xs={12}>
                              <Typography
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  color: "#0E3F6F",
                                }}
                              >
                                Certificate
                              </Typography>
                              <Typography
                                component="a"
                                href={item.certificateImageUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                  fontSize: "15px",
                                  color: "#2563eb",
                                  cursor: "pointer",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 1,
                                  textDecoration: "none",
                                  "&:hover": { textDecoration: "underline" },
                                }}
                              >
                                📄 View Document
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>

              {/* ------------------ DOCUMENTS ------------------ */}
              {isSameVendor && (
                <Box sx={{ mt: 5 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                    }}
                  >
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        background: "#E6F0F8",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FileOpenOutlined
                        sx={{
                          color: "#286a94",
                          fontSize: 22,
                        }}
                      />
                    </Box>

                    <Typography variant="h6" fontWeight={700} color="#286a94">
                      Documents
                    </Typography>
                  </Box>

                  <Divider sx={{ my: 3 }} />

                  {(() => {
                    const docs = [];

                    if (userInfo?.panCardUrl) {
                      docs.push({
                        title: "PAN Card",
                        fileUrl: userInfo.panCardUrl,
                        number: userInfo.panCardNumber,
                      });
                    }

                    if (userInfo?.aadhaarCardUrl) {
                      docs.push({
                        title: "Aadhaar Card",
                        fileUrl: userInfo.aadhaarCardUrl,
                        number: userInfo.aadharCardNumber,
                      });
                    }

                    if (userInfo?.governmentTaxIdUrl) {
                      docs.push({
                        title: "Government Tax ID",
                        fileUrl: userInfo.governmentTaxIdUrl,
                        number: userInfo.governmentTaxId,
                      });
                    }

                    if (userInfo?.governmentIdUrl) {
                      docs.push({
                        title: "Government ID",
                        fileUrl: userInfo.governmentIdUrl,
                        number: userInfo.governmentId,
                      });
                    }

                    return (
                      <>
                        {docs.length === 0 && (
                          <Box
                            sx={{
                              p: 4,
                              textAlign: "center",
                              border: "2px dashed #bcd3df",
                              borderRadius: 3,
                              background: "#f8fcff",
                              color: "#475569",
                            }}
                          >
                            📁 No documents uploaded yet.
                          </Box>
                        )}

                        {/* Documents List */}
                        {docs.length > 0 && (
                          <Box sx={{ mt: 2 }}>
                            {docs.map((doc, idx) => (
                              <Box
                                key={idx}
                                sx={{
                                  background: "#F9FAFB",
                                  border: "1px solid #E5E7EB",
                                  p: 2.5,
                                  borderRadius: 3,
                                  mb: 2.5,
                                }}
                              >
                                {/* Header */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    mb: 2,
                                  }}
                                >
                                  <Chip
                                    label={`#${idx + 1}`}
                                    sx={{
                                      background: "#286a94",
                                      color: "white",
                                      mr: 2,
                                      fontWeight: 600,
                                    }}
                                  />
                                  <Typography
                                    sx={{ fontSize: "18px", fontWeight: 600 }}
                                  >
                                    {doc.title}
                                  </Typography>
                                </Box>

                                {/* Info Grid */}
                                <Grid container spacing={2}>
                                  {/* Number / ID */}
                                  {doc.number && (
                                    <Grid item xs={12} sm={6}>
                                      <Typography
                                        sx={{
                                          fontWeight: 600,
                                          fontSize: "14px",
                                          color: "#0E3F6F",
                                        }}
                                      >
                                        Number / ID
                                      </Typography>
                                      <Typography
                                        sx={{
                                          fontSize: "15px",
                                          color: "#475569",
                                        }}
                                      >
                                        {doc.number}
                                      </Typography>
                                    </Grid>
                                  )}

                                  {/* File Link */}
                                  <Grid item xs={12} sm={6}>
                                    <Typography
                                      sx={{
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        color: "#0E3F6F",
                                      }}
                                    >
                                      Document
                                    </Typography>

                                    <Typography
                                      component="a"
                                      href={doc.fileUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      sx={{
                                        fontSize: "15px",
                                        color: "#2563eb",
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 1,
                                        textDecoration: "none",
                                        "&:hover": {
                                          textDecoration: "underline",
                                        },
                                      }}
                                    >
                                      📄 View Document
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Box>
                            ))}
                          </Box>
                        )}
                      </>
                    );
                  })()}
                </Box>
              )}

              {/* PRICING */}
              {isSameVendor &&
                userInfo?.isBillable &&
                parseInt(userInfo?.keyExperience || 0) >= 1 && (
                  <>
                    <Divider sx={{ my: 3 }} />
                    <Pricing Id={candidateId} />
                  </>
                )}
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Dialog
        open={openResume}
        onClose={() => setOpenResume(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: 600,
          }}
        >
          Resume Preview
          <IconButton onClick={() => setOpenResume(false)}>
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 0 }}>
          <iframe
            src={userInfo.resumeFileUrl}
            title="Resume"
            width="100%"
            height="520px"
            style={{ border: "none" }}
          />
        </DialogContent>

        {/* <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setOpenResume(false)}
            sx={{ textTransform: "none" }}
          >
            Close
          </Button>

          <Button
            variant="contained"
            component="a"
            href={userInfo.resumeFileUrl}
            target="_blank"
            sx={{ textTransform: "none" }}
          >
            Open in New Tab
          </Button>
        </DialogActions> */}
      </Dialog>

      {/* VIDEO MODAL */}
      <VideoModal
        showModal={showVideoModal}
        handleClose={() => setShowVideoModal(false)}
        title="Introduction"
        body={
          userVideo ? (
            <video width="100%" height="300px" controls>
              <source src={userVideo} type="video/mp4" />
            </video>
          ) : (
            <img
              src={videoThumb}
              alt="No Video"
              style={{ width: "100%", maxHeight: 300, objectFit: "cover" }}
            />
          )
        }
      />
    </>
  );
};

export default ViewCandidate;
